import { getRgObjectsOfType as g, RG_TYPE as f } from "@project-rouge/rg-core";
import { getPolygonCornerCount as a } from "../../../geometry-utils/core/index15.js";
const u = (n, r) => {
  let o = 0;
  const t = g(n, f.Building);
  for (const e of t)
    o += d(e, r);
  return o;
};
function d(n, r) {
  const o = n.data.levels.filter((e) => e.levelIndex === r);
  let t = 0;
  for (const e of o) {
    const i = n.children.find((l) => l.type === f.Facade && l.data.levelId === e.uuid);
    if (!!i) {
      if (e.geaPolygon)
        t += a(e.geaPolygon).external * i.size[1];
      else if (e.roofFacadePerimeter)
        for (const l of e.roofFacadePerimeter)
          t += a(l).external * i.size[1];
    }
  }
  return t;
}
export {
  u as getLevelFacadeExternalCornerLength
};
//# sourceMappingURL=index16.js.map
